import { Koi } from '@ksyos/koi';
import type { SavePrickTestMeasurementsRequestBody } from '@common/validation/evidencio/evidencio';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { savePrickTestMeasurementsRequestBodyValidation } from '@common/validation/evidencio/evidencio';

export type RespiAllerPrickTestMeasurementsFinalCustomControlData = SavePrickTestMeasurementsRequestBody;

export type RespiAllerPrickTestMeasurementsDraftCustomControlData = Record<string, never>;

type TypedRespiAllerPrickTestMeasurementsFinalSchema =
    TypedSchema<RespiAllerPrickTestMeasurementsFinalCustomControlData>;

const respiAllerPrickTestMeasurementsBaseSchema: TypedRespiAllerPrickTestMeasurementsFinalSchema =
    savePrickTestMeasurementsRequestBodyValidation;

export const respiAllerPrickTestMeasurementsDraftSchema = Koi.object({});
export const respiAllerPrickTestMeasurementsFinalSchema = Koi.object(respiAllerPrickTestMeasurementsBaseSchema);
